// extracted by mini-css-extract-plugin
module.exports = {"agentBox":"AgentNotService_agentBox__v3_uG","header":"AgentNotService_header__XLa1d","content":"AgentNotService_content__cYtz_"};